<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Configure CAPA Review Committee
							</div>
							<!-- Page Header -->
							<div class="page_main">
								<div class="training-type-page">
									<div class="tip-box">
										Configure the set of roles used to determine approvers during the formal review of CAPA requests. If no review committee roles are defined, the department list will be used instead.
									</div>

									<div class="panel">
										<div class="panel-header">
											<h2 class="panel-title">
												CAPA Review Committee Members
											</h2>
										</div>

										<el-table
											v-loading="tableLoading"
											:data="tableData"
											border
											stripe
											header-cell-class-name="table-header-cell"
											cell-class-name="table-body-cell"
											class="training-table"
											empty-text="No Data"
										>
											<el-table-column
												label="Action"
												width="80"
												fixed="left"
												align="center"
											>
												<template slot-scope="scope">
													<el-button
														type="primary"
														size="mini"
														@click="handleEdit(scope.row)"
													>
														Edit
													</el-button>
												</template>
											</el-table-column>

											<el-table-column
												prop="role_name"
												label="Approver Role"
												min-width="260"
												sortable
											/>

											<el-table-column
												prop=""
												label="Optional Default Approver"
												min-width="280"
												sortable
											>
												<template slot-scope="scope">
													{{ scope.row.username || 'N/A' }}
												</template>
											</el-table-column>

											<el-table-column
												label="Action"
												width="120"
												align="center"
											>
												<template slot-scope="scope">
													<el-button
														type="danger"
														size="mini"
														@click="handleDelete(scope.row)"
													>
														Delete
													</el-button>
												</template>
											</el-table-column>
										</el-table>

										<div class="panel-footer">
											<el-button
												type="primary"
												@click="handleAdd"
											>
												Add CAPA Review Committee Member
											</el-button>

											<el-button
												type="primary"
												@click="handleClose"
											>
												Cancel
											</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>

		<!-- Loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!-- Loading -->
	</div>
</template>

<script>
import { capausersList, capausersDel } from '@/api/capaManage/configCapa/capaReview/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";

export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			tableLoading: false,
			query: {
				role_name: '',
				page: 1,
				page_size: 9999
			},
			tableData: [],
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		that.getTableData();
	},
	methods: {
		// Get table data
		getTableData() {
			let that = this;
			that.tableLoading = true;
			capausersList(that.query).then(res => {
				that.tableLoading = false;
				if (res.code == 200) {
					that.tableData = res.data;
				}
			});
		},

		// Add
		handleAdd() {
			let that = this;
			that.goUrl("/CapaControl/review-add-edit");
		},

		// Edit
		handleEdit(row) {
			let that = this;
			that.$router.push({
				path: '/CapaControl/review-add-edit',
				query: { oid: row.id }
			});
		},

		// Delete
		handleDelete(row) {
			let that = this;
			that.$confirm(
				'Are you sure you want to delete this member?',
				'Confirmation',
				{
					type: "warning",
				}
			).then(() => {
				that.$toast.loading({
					duration: 0,
					forbidClick: true
				});

				capausersDel({ id: row.id }).then(res => {
					if (res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation successful');

						setTimeout(() => {
							that.getTableData();
						}, 800);
					}
				});
			}).catch(() => {});
		},

		handleClose() {
			let that = this;
			that.$router.back();
		},

		// Navigate to page
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	}
}
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-type-page {
  padding: 16px 12px 30px;
  background: #f5f6f7;
  min-height: 100vh;
  box-sizing: border-box;
}

.tip-box {
  background: #f6efdf;
  border-radius: 4px;
  color: #333;
  padding: 14px 16px;
  margin-bottom: 14px;
  font-size: 14px;
  line-height: 24px;
}

.tip-title {
  font-weight: 700;
}

.tip-list {
  margin: 8px 0 0 18px;
  padding: 0;
}

.tip-list li {
  line-height: 26px;
}

.panel {
  background: #fff;
  border: 1px solid #dcdfe6;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 8px;
  border-bottom: 1px solid #dcdfe6;
}

.panel-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #222;
}

.panel-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 220px;
}

.collapse-btn {
  width: 28px;
  height: 28px;
  padding: 0;
}

.training-table {
  width: 100%;
}

::v-deep .table-header-cell {
  background: #fff !important;
  color: #222;
  font-weight: 700;
  font-size: 16px;
}

::v-deep .table-body-cell {
  color: #222;
  font-size: 15px;
}

::v-deep .el-table td,
::v-deep .el-table th {
  padding: 14px 0;
}

::v-deep .el-table--border th,
::v-deep .el-table--border td {
  border-right: 1px solid #dcdfe6;
}

::v-deep .el-button--mini {
  padding: 7px 12px;
  font-size: 14px;
}

.panel-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 24px 0 28px;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

